// import goa from '../../assets/images/goa.jpg'
import manali from "../../assets/images/manali.jpg";
// import singapore from '../../assets/images/singapore.jpg'
// import abu from '../../assets/images/abu-dhabi.jpg'
// import ooty from '../../assets/images/ooty.jpg'
import kashmir from "../../assets/images/kashmir.jpg";
import Varnasi from "../../assets/images/varansi.jpg";
import murugan from "../../assets/images/domestic.jpeg";
import kerela from "../../assets/images/kerela.jpg";
import Darjeeling from "../../assets/images/darjeeling.jpg";
import Ladakh from "../../assets/images/leh-ladak-.jpg";
import Guwahati from '../../assets/images/Guwahati.jpg'
import Chardham from '../../assets/images/Chardham.jpg'


import kashmir1 from '../../assets/images/DomIng/kashmir 1.jpg'
import kashmir2 from '../../assets/images/DomIng/kashmir 2.jpg'
import kashmir3 from '../../assets/images/DomIng/kashmir 3.jpg'
import kashmir4 from '../../assets/images/DomIng/kashmir 4.jpg'
import kashmir5 from '../../assets/images/DomIng/kashmir 5.jpg'


import arupadai1 from '../../assets/images/packagesImg/arupadai/arupadai1.jpg'
import arupadai2 from '../../assets/images/packagesImg/arupadai/arupadai2.jpg'
import arupadai3 from '../../assets/images/packagesImg/arupadai/arupadai3.jpg'
// import arupadai4 from '../../assets/images/packagesImg/arupadai/arupadai4.jpg'
import arupadai5 from '../../assets/images/packagesImg/arupadai/arupadai5.jpg'
import arupadai6 from '../../assets/images/packagesImg/arupadai/arupadai6.jpg'
// import arupadai7 from '../../assets/images/packagesImg/arupadai/arupadai7.jpg'
import arupadai8 from '../../assets/images/packagesImg/arupadai/arupadai8.jpg'
import arupadai9 from '../../assets/images/packagesImg/arupadai/arupadai9.jpg'

import kerela1 from '../../assets/images/DomIng/Kerala 1.jpg'
import kerela2 from '../../assets/images/DomIng/Kerala 2.jpg'
import kerela3 from '../../assets/images/DomIng/Kerala 3.jpg'
import kerela4 from '../../assets/images/DomIng/Kerala 4.jpg'
import kerela5 from '../../assets/images/DomIng/Kerala 5.jpg'


import ladak from '../../assets/images/DomIng/Ladakh 1.jpg'
import ladak1 from '../../assets/images/DomIng/Ladakh 2.jpg'
import ladak2 from '../../assets/images/DomIng/Ladakh 3.jpg'
import ladak3 from '../../assets/images/DomIng/Ladakh 4.jpg'
import ladak4 from '../../assets/images/DomIng/Ladakh 5.jpg'
import ladak5 from '../../assets/images/DomIng/Ladakh 6.jpg'
import ladak6 from '../../assets/images/DomIng/Ladakh 7.jpg'



import Char from '../../assets/images/DomIng/Char dham yatra 1.jpg'
import Char1 from '../../assets/images/DomIng/Char dham yatra 2.jpg'


import shimla1 from '../../assets/images/DomIng/Shimla & Manali 1.jpg'
import shimla2 from '../../assets/images/DomIng/Shimla & Manali 2.jpg'
import shimla3 from '../../assets/images/DomIng/Shimla & Manali 3.jpg'
import shimla4 from '../../assets/images/DomIng/Shimla & Manali 4.jpg'
import shimla5 from '../../assets/images/DomIng/Shimla & Manali 5.jpg'
import shimla6 from '../../assets/images/DomIng/Shimla & Manali 6.jpg'
import shimla7 from '../../assets/images/DomIng/Shimla & Manali 7.jpg'

import Guwahati1 from '../../assets/images/DomIng/Guwahati 1.jpg'
import Guwahati2 from '../../assets/images/DomIng/Guwahati 2.jpg'
import Guwahati3 from '../../assets/images/DomIng/Guwahati 3.jpg'
import Guwahati4 from '../../assets/images/DomIng/Guwahati 4.jpg'
import Guwahati5 from '../../assets/images/DomIng/Guwahati 5.jpg'

import Varnasi1 from "../../assets/images/DomIng/Varanasi 1.jpg";
import Varnasi2 from "../../assets/images/DomIng/Varanasi 2.jpg";
import Varnasi3 from "../../assets/images/DomIng/Varanasi 3.jpg";
import Varnasi4 from "../../assets/images/DomIng/Varanasi 4.jpg";
import Varnasi5 from "../../assets/images/DomIng/Varanasi 5.jpg";
import Varnasi6 from "../../assets/images/DomIng/Varanasi 6.jpg";

import Darjeeling1 from "../../assets/images/DomIng/Darjeeling 1.jpg";
import Darjeeling2 from "../../assets/images/DomIng/Darjeeling 2.jpg";
import Darjeeling3 from "../../assets/images/DomIng/Darjeeling 3.jpg";
import Darjeeling4 from "../../assets/images/DomIng/Darjeeling 4.jpg";
import Darjeeling5 from "../../assets/images/DomIng/Darjeeling 5.jpg";
import Darjeeling6 from "../../assets/images/DomIng/Darjeeling 6.jpg";




export const packageData = [
  {
    img: kashmir,
    country: "India",
    place: "Kashmir",
    tripDur: "6 Days 5 Nights Best of KashmirScenic Delight Tour ",
    imgs: [kashmir, kashmir1, kashmir2, kashmir3, kashmir4 , kashmir5],
    title:"",
    subDesc:"",
    days: [
      {
        title: "Day 01:  DELHI/ SRINAGAR  (Kashmir) (Dinner) Domestic  flight ",
        desc: ["Depart from Delhi or Chennai for Srinagar flight via Delhi, to Srinagar, the Summer capital of Kashmir at the height of 5200 ft above sea level, which is located on the foot of Himalayan Mountains, where tourist enjoy living in e Houseboats which are anchored on famous Dal Lake. A Kashmiri warm welcome greets you on arrival from airport to jetty by cars and noon which transfer to Deluxe Houseboats by Gondola (shikara) After  noon cruise on Dal Lake  visiting the Floating garden, Lotus gardens( summers), back waters of the lake, cruise will go through canals. visit to the handicrafts center walnut wood work by Shikara, look for pure Pashmina Shawl while you are in Kashmir follow by visit to  famous Mughal Gardens build by Mughal Emperors during their rule   of Kashmir  First visit  Nishat (Garden of pleasure) built by Asif Khan brother in law of Jehangir in 1632 AD overlooking the crystal clear Emerald green waters of  the Dal lake then to Shalimar (Garden of Love) built by Mughal Emperor Jehangir for his wife Empress Noor Jehan. During spring until Autumn these gardens are full of flowers. Dinner and stay at BostanGulistan Premium Deluxe Houseboats. (4 *)"],
      },
      {
        title: "Day 02: SRINAGAR/GULMARG/SRINAGAR ( B/D )",
        desc:
          ["After breakfast enjoy an excursion 54 kms  to Gulmarg ( Meadow of Flowers ) at a height of 8800ft above sea level. Here you will witness the beauty of Nature surroundings of Kashmir set out like a Doll’s village enroute stop at few villages to witness the country life of Kashmiris. Gulmarg used to be a favourite hunt of the British in summers and you will find old fashioned hotels and shops in the village. One can also have the view of Nanga Parbhat (26,600 ft) if weather permits. Gulmarg  has highest 18 hole golf course in the world and has developed into a famous Ski resort. take a  gondola ride ( cable car ride  Include in cost First Phase)  from 8800 ft to 10 200 ft ASL  high above the meadows and snow covered slopes of Apherwat and Khilanmarg mountain which provide a play ground for skiing, tobogganing, pony ride. Return to Srinagar. Jammia Masjid  the biggest Mosque in Kashmir with beautiful architecture with influence from Chinese pagoda style known as Indo- Saracenic architecture, and explore the local spice bazaar abd local bazaar, , Dinner and over night stay in Houseboat.",
          ]
      },
      {
        title: "SRINAGAR – SONAMARG  (B/D)",
        desc:
          ["Depart early morning after breakfast for a wonderful trip with Picnic lunch to  Sonamarg (Meadow of Gold) at a distance of 86kms,one way 3 hours drive situated at a height of 8900 feet above sea level. The distance will take about 2 hours drive up to Sonamarg which goes along the Sindh River. It is also known as the Sindh Valley Tour. The drive isdrive up to Sonamarg which goes along the Sindh River.  It is also known as the Sindh Valley. The drive is very spectacular with beautiful sceneries along the way, enroute stop at  Kangan town, an interesting small mountain town where mountain people from the surrounding valleys come down for trading. Once you reach Sonamarg you will feel like you are in the Swiss Alps. The meadows of Sonamarg have a spectacular beauty from the strewn with the loveliest of Alpine flowers, lots of Fir and Pine and Silver Birch trees. explore the Sonamarg valley and  trek to Thajwas Glacier either on foot or on ponies (own expenses)  later in the evening return back to Srinagar. and visit  Hazratbal Mosque situated on the banks of Dal lake,  the Only Dome shaped mosque in Kashmir, walk through market, later evening return to Houseboat for  Dinner and overnight stay. ",
          ]
      },
      {
        title:
          "Day 04: SRINAGAR / PAHALGAM  (Valley of Shepherds)  (B/D) Over night stay in Pahalgam ",
        desc:
          ["After breakfast  excursion and over night trip  to Pahalgam 96  kms  one way at 2 400 meters above sea level. The drive through pine mountains and cascading Lidder river and idyllic resort for relaxation. TheLidder river offers an excellent opportunity for trout fishing .Enroute visit  Cricket bat factory and  Pampore Saffron fields, Anantnag town the second largest town of Kashmir. The walk through Ananthnag town will be very interesting one,  going through small lanes and witnessing Kashmiri countryside life. Rafting Point  sightseeing, Pahalgam is known for take off point for treks in the surrounding Himalyan mountains. Arrive Pahalgam and enjoy the beautiful sceneries all around,   Pahalgam is famous place for Indian Film industry, arrive Pahlgam check in hotel relax , Poshwan Park sightseeing tour,  later afternoon visit Beetab Valley very famous  tourist spot, where many film shooting has been going on for many years and it has beautiful sceneries all around,  Dinner and over night stay in Pahalgam mountain resort,  later  optional pony trekking tour to the surrounding Mountain trails to Baisaran Meadows ,on ponty s( own expenses) with magnificent view of the  Himalayan Mountains, Dinner and over night stay in Pahalgam resort Hotel Hil Top.",
          ]
      },
      {
        title: "Day 05:  PAHALGAM/ SRINAGAR   (B/D)",
        desc:
          ["After breakfast explore the beauty of this resort and walk through meadows later return to Srinagar check in hotel after freshen up later visit  Residency Road and shop in local market, explore Srinagar local life in and last minute Shopping, Dinner and over night stay in Srinagar Hotel. Asian Park.",
          ]
      },
      {
        title: "SRINAGAR/ DELHI or CHENNAI (B)",
        desc:
          ["Morning after breakfast free and easy explore the town and  later transfer to airport for flight to Delhi or Chennai,",
          ]
      },
    ],
  },
  {
    img: Varnasi,
    country: "India",
    place: "Varanasi",
    tripDur: "06 Days 05 Nights Varanasi Package.",
    title:"",
    subDesc:"",
    imgs: [Varnasi , Varnasi1 , Varnasi2 , Varnasi3 , Varnasi4 , Varnasi5 , Varnasi6],
    days: [
      {
        title: "Day 01 : Varanasi Arrival & Ganga Aarti",
        desc:
          ["Our services start on your arrival at Lal Bahadur Shastri International Airport/ Railway Station.Meet & greet and transfer to the hotel. Check in to the hotel. Take some time to freshen up andrelax. In the evening proceed to witness the Ganga Aarti at Dashashwamedh Ghat and afterAarti visit Kashi Vishwanath Temple, Vishalakshi and Annapurna temple. Stay Overnight at Varanasi.",
          ]
      },
      {
        title: "Day 02 : Local Temples – Sarnath & Namo Ghat",
        desc:
          ["After having breakfast, proceed to visit Baba Kaal Bhairav Temple, Sankat Mochan, Tulsi Manas Temple, Durga Ji and Birla Temple. Here drive to Sarnath- A very important place of pilgrimage for Buddhists, the Place where Buddha gave his first sermon. Here visit Dhamek Stupa, Sarnath Archaeological Museum, Tibetan Buddhist Monastery, Ashoka Pillar. After that in the evening visit Namo ghat statues in a welcome gesture, a new NaMo Ghat is touches in the Ganga downstream. Two 25-ft-tall and one and one smaller ‘namaste’ statues have already been installed. Back to hotel for Overnight stay at Varanasi.",
          ]
      },
      {
        title: "Day 03 –Varanasi – Bodhgaya Local",
        desc:
          ["Have breakfast & check out from the hotel and drive to Bodh Gaya (270 km) Check in the hotel, Rest & visit to Mahabodhi Temple, the statue of Lord Buddha, Bodhi Tree, Chinese temple, Tibetan temple, Japanese temple, Phalguna River and others Tibetan refuse market, Thai Monastery, etc. later back to hotel & overnight stay at in hotel.",
          ]
      },
      {
        title: "Day 04 – Bodhgaya – Gaya- Varanasi",
        desc:
          ["After breakfast, checkout the hotel & you will be taken on a road trip to Gaya. Gaya is famous for unique temples. There is a temple in Gaya where you can find Lord Vishnu’s footprint, called Vishupad temple. Then drive to Varanasi. Check in to the hotel. Rest and overnight stay.",
          ]
      },
      {
        title: "Day 05: Varanasi – Prayagraj Local- Ayodhya",
        desc:
          ["Post breakfast checkout and transfer to Prayagraj. Proceed to visit Sangam- the sacred spot of the confluence of three holy rivers – Ganga, Yamuna and mythical Saraswati. The confluence spot can be reached by boat (on direct payment) then visit local sightseeing- Prayagraj visit local sightseeing-Hanuman Mandir, Anand Bhawan, Akbar Fort & Allahabad Museum. Now drive to Ayodhya . On arrival, check in to the Hotel and rest and overnight stay",
          ]
      },
      {
        title: "Day 06 : Ayodhya Local & Varanasi Drop",
        desc:
          ["Post breakfast checkout and Now proceed to visit Ayodhya-the birthplace of Lord Rama, Saryu River, Shri Hanuman Garhi Mandir , Dashrath Bhawan, Kanak Bhawan visit Ram Janam Bhoomithe birthplace of Lord Rama and visit the temple of Ayodhya. Now Catch a flight or train to head home from Varanasi.",
          ]
      },
    ],
  },
  {
    img: murugan,
    country: "India",
    place: "Arupadi Vedu",
    tripDur: "07 Nights / 08 Days",
    title: "Sacred Sojourn: A Journey Through the Arupadai Veedu Temples",
    subDesc:"",
    imgs: [ arupadai1, arupadai2, arupadai3, arupadai5, arupadai6, arupadai8, arupadai9],
    days: [
      {
        title: "Day 1:- Trichy",
        desc: ["•	Arrival at Trichy, airport pickup.", "•	Visit Uchipilliar, Samayapuram Mariamman, Srirangam Ranganathar, and Tiruvanaikovil Jambulingeswarar temples.", "•	Stay at Trichy."],
      },
      {
        title: "Day 2:- Trichy  to Palani (3 ½ Hours) ",
        desc: ["•	Morning transfer to Palani.", "•	Darshan at Palani Dhandayuthapani Swami Temple (Third Padaiveedu).", "•	Stay at Palani."]
      },
      {
        title: "Day 3 : Palani to Madurai (2 ½ Hours) ",
        desc: ["•	Visit Thiruparankundram Murugan Temple (First Padaiveedu).", "•	Explore Madurai Meenakshi Amman Temple.", "•	Darshan at Pazhamudhircholai Murugan Temple (Sixth Padaiveedu).", "•	Stay at Madurai."],
      },
      {
        title: "Day 4:- Madurai to Tiruchendur (4 Hours)",
        desc: ["•	Drive to Tiruchendur.", "•	Darshan at Tiruchendur Murugan Temple (Second Padaiveedu).", "•	Stay at Tiruchendur."],
      },
      {
        title: "Day 5:- Tiruchendur to  Rameswaram (5 Hours)",
        desc: ["•	Transfer to Rameswaram.", "•	Darshan at Ramanathaswamy Temple.", "•	Stay at Rameswaram.",]
      },
      {
        title: "Day 6:- Rameswaram to Kumbakonam (6 Hours)",
        desc: ["•	Transfer to Kumbakonam.", "•	Visit various temples in Kumbakonam.", "•	Stay at Kumbakonam."],
      },
      {
        title: "Day 7:- Kumbakonam to Chennai",
        desc: ["•	Visit Swamimalai Temple (Fourth Padaiveedu).", "•	Drive to Thiruthani Murugan Temple (Fifth Padaiveedu).", "•	Transfer to Chennai.", "•	Stay at Chennai."],
      },
      {
        title: "Day 8: Chennai Airport Departure",
        desc: ["•	Airport transfer for onward journey."]
      },
    ],
    days1: [
      {
        title: "Day 1: Arrival in Trichy",
        desc: `As the family’s airplane landed in Trichy, the bustling airport buzzed with excitement. Karthik, the husband, welcomed his parents and his wife, Priya, alongside their curious little son, Aarav.
 
“Welcome to Trichy, everyone! Ready for our temple tour?” Karthik asked, his enthusiasm infectious.
 
“Absolutely! I can’t wait to visit all the temples,” Priya replied, holding Aarav’s hand as they stepped out of the airport.
 
Their first stop was the Uchipillaiyar Temple, known for its stunning architecture and serene atmosphere. As they climbed the steps, Karthik's mother, Meena, turned to Priya, her eyes sparkling.
 
“This place is beautiful, isn’t it? It reminds me of my childhood visits with my parents,” Meena reminisced.
 
“It really is, Aunty. I feel a special connection to the divine here,” Priya responded, feeling a warmth grow between them.
 
After the temple visit, they made their way to the Samayapuram Mariamman Temple, where Aarav excitedly ran ahead, his innocent laughter echoing through the sacred space.
 
“Look at him, Priya! He’s full of energy!” Karthik chuckled, watching their son explore.
 
“Just like you were at his age, Karthik!” Meena chimed in, laughing together as they followed Aarav’s lead.
 
Their day concluded with a visit to the Srirangam Ranganathar Temple and the Tiruvanaikovil Jambulingeswarar Temple, each place strengthening their bond as they shared stories and prayers."`,
      },
      {
        title: "Day 2: Trichy to Palani",
        desc: `After breakfast, the family set out on the drive to Palani, excitement bubbling within them.
 
“Palani is known for the Dhandayuthapani Swami Temple,” Karthik said, glancing at his family. “It’s one of the most revered temples dedicated to Lord Murugan.”
 
The journey took approximately three and a half hours, with scenic views of the countryside unfolding before them. When they arrived at the temple, the air was thick with devotion and the scent of incense.
 
“Let’s go for darshan!” Priya urged, her heart racing with anticipation.
 
As they entered, Meena took Priya’s hand and squeezed it gently. “I’m glad we’re experiencing this together,” she said softly, appreciating the spiritual connection forming between them.
 
“This is such a beautiful temple, Aunty! I feel so blessed to be here,” Priya replied, her voice filled with reverence.
 
After darshan, they checked into their hotel, reflecting on the day’s experiences.
 
“Thank you for bringing us along, Karthik. This trip is special,” Meena said, beaming at her son.
`,
      },
      {
        title: "Day 3: Palani to Madurai",
        desc: `The next morning, after breakfast, they packed their bags and set off towards Madurai, stopping first at Tiruparankundram.
 
“This is the first of the Arupadai Veedu temples,” Karthik explained, his pride evident. “Let’s offer our prayers.”
 
After their visit, they continued to Pazhamudhirchoolai, where the scenic drive took them through lush landscapes.
 
“Look at that view!” Aarav exclaimed, pressing his face against the window.
 
“It’s breathtaking, isn’t it?” Priya replied, smiling at her son’s wonder.
 
As they reached Pazhamudhirchoolai Temple, Meena shared her memories of visiting with Karthik as a child. “We always made a wish here, and it came true,” she said, her voice nostalgic.
 
“I love hearing your stories, Aunty. They make this journey even more special,” Priya said, feeling more connected to her mother-in-law.
 
After a fulfilling day, they settled in for the night at their hotel in Madurai, the bond between Priya and Meena growing deeper with each shared experience.
`,
      },
      {
        title: "Day 4: Madurai to Tiruchendur",
        desc: `With the dawn of a new day, the family left Madurai early, heading to Tiruchendur.
 
“Today, we’ll visit the Tiruchendur Arulmigu Subramaniya Swami Temple,” Karthik announced as they drove.
 
Upon arrival, the temple’s beauty captivated them. “This temple is so vibrant! I love the colors,” Aarav exclaimed, pulling on Priya’s arm.
 
“Just like you, sweetheart!” she replied, laughing as they entered the temple for darshan.
 
As they stood in prayer, Meena whispered to Priya, “I feel a sense of peace here. It’s wonderful to share this with you.”
 
Priya nodded, her heart swelling with gratitude. “I feel it too, Aunty. This trip is bringing us closer.”
 
They stayed the night in Tiruchendur, hearts full of gratitude for the blessings received.
`,
      },
      {
        title: "Day 5: Tiruchendur to Rameswaram",
        desc: `The following morning, they set off for Rameswaram, a five-hour journey filled with laughter and stories.
 
“Today, we’ll visit the Ramanathaswamy Temple,” Karthik shared, excitement palpable in his voice.
Upon reaching Rameswaram, the family was in awe of the temple’s Dravidian architecture.
 
“Wow! This place feels so sacred,” Aarav said, eyes wide with wonder.
 
“Indeed, son. This is a significant pilgrimage site,” Karthik explained, as they entered the temple for the Shpatik Linga darshan.
 
As they stood in prayer, Meena whispered to Priya, “I’ve watched you with Aarav, and I must say, you’re doing a wonderful job as a mother.”
 
“Thank you, Aunty. That means a lot coming from you,” Priya said, feeling grateful for the affirmation.
 
They stayed the night in Rameswaram, appreciating the experiences shared and lessons learned.
`,
      },
      {
        title: "Day 6: Rameswaram to Kumbakonam",
        desc: `With the sun rising, the family departed for Kumbakonam, a six-hour drive through the picturesque landscape.
 
“I’ve heard Kumbakonam is famous for its temples,” Karthik mentioned as they journeyed.
 
“Let’s explore some of them!” Priya suggested, her enthusiasm infectious.
After checking into their hotel, they visited several temples, marveling at the intricate carvings and vibrant festivals.
 
“This place is filled with history,” Meena remarked, impressed by the cultural richness.
Priya smiled, watching her mother-in-law appreciate the heritage. “I’m so glad we’re experiencing this together.”
 
As the day came to a close, their hearts were full, and the family felt a stronger connection.
`,
      },
      {
        title: "Day 7: Kumbakonam to Chennai",
        desc: `After breakfast, they checked out and headed to Swamimalai, where they visited the Swaminatha Swami Temple.
 
“This temple is the fourth among the Arupadai Veedu temples,” Karthik explained.
Priya and Meena admired the beauty of the temple. “It’s so peaceful here,” Priya remarked, soaking in the tranquility.
 
After darshan, they embarked on their journey to Thiruthani. The drive was long but filled with laughter as Aarav shared jokes, lightening the atmosphere.
 
“Dad, why did the chicken cross the road?” Aarav giggled.
 
“Why?” Karthik asked, playing along.
 
“To get to the other side!” Aarav roared with laughter, and soon everyone joined in.
 
They reached Thiruthani in the evening for the darshan of the Lord Murugan Temple. “This is the last of the Arupadai Veedu temples,” Karthik said, feeling the weight of their spiritual journey.
 
After prayers, Meena hugged Priya tightly. “Thank you for being such a wonderful daughter-in-law.
 
This journey has meant so much to me.”
 
“I feel the same, Aunty. I’m grateful for the bond we’ve built,” Priya replied, her heart full of love.
Finally, they drove to Chennai, where they would spend their last night together.

`,
      },
      {
        title: "Day 8: Departure from Chennai",
        desc: `The following morning, they had their final breakfast together before heading to the airport.
 
“Thank you for an incredible journey,” Karthik said, glancing around the table.
 
“I’ll cherish these moments forever,” Meena added, her eyes misty with emotion.
 
“Can we do this again next year?” Aarav asked eagerly.
 
“Of course, sweetheart,” Priya replied, her smile beaming. “We’ll make more memories together.”
As they headed to the airport, the family felt a profound sense of connection, strengthened by their shared experiences and spiritual journey.
 
“Until our next adventure,” Karthik said, looking at his family with gratitude.
 
“Let’s keep this spirit alive,” Meena added, feeling proud of the bond they had nurtured.
 
 
The journey to the Arupadai Veedu temples had not only deepened their faith but had also woven a tapestry of love and understanding among them—a sacred sojourn they would hold dear forever.
`,
      },
    ],

  },
  {
    img: kerela,
    country: "India",
    place: "Kerela",
    tripDur: "04 Nights and 05 Days ",
    title: "Glimpses of Kerala: A Journey of Reconnection",
    subDesc:"",
    imgs: [kerela, kerela1, kerela2, kerela3, kerela4, kerela5],
    days: [
      {
        title: "Day 1 : Cochin Arrival - Munnar",
        desc: ["•	Arrival in Cochin, transfer to Munnar (4 hours drive).", "•	Visit Valara & Cheeyappara waterfalls, tea plantations.", "•	Check-in at the hotel.", "•	Afternoon visit to Rajamala (Eravikulam National Park) & Tea Museum.", "•	Explore Munnar town.", "•	Stay at Munnar."]
      },
      {
        title: "Day 2: Munnar - Full Day Sightseeing",
        desc: ["•	Full day sightseeing in Munnar: Mattupetty Dam, Echo Point, Kundala Dam, Pothamedu View Point, Blossom Park.", "•	Shopping & stay at Munnar."]
      },
      {
        title: "Day 3: Munnar to Thekkady - Transfer & Sightseeing",
        desc: ["•	Transfer to Thekkady, check-in at hotel.", "•	Visit Periyar Wildlife Sanctuary, Spice Plantation.", "•	Stay at Thekkady."]
      },
      {
        title: "Day 4: Thekkady to Alleppey - Transfer & Houseboat Stay",
        desc: ["•	Transfer to Alleppey.", "•	Check-in to a houseboat for a backwater cruise.", "•	Overnight stay on the houseboat."]
      },
      {
        title: "Day 5: Alleppey to Cochin - Transfer & Sightseeing",
        desc: ["•	Check out from houseboat, drive to Cochin.", "•	Half-day sightseeing in Cochin: Jewish Synagogue, St. Francis Church, Dutch Palace, Chinese fishing nets.", "•	Departure from Cochin."]
      },
    ],
    days1: [
      {
        title: "Day 1: Arrival in Cochin – Munnar",
        desc: `As the airplane touched down in Cochin, the lush greenery of Kerala unfolded like a vibrant carpet beneath them. Raj and his son, Aryan, stepped out of the airport, their hearts buzzing with excitement for the adventure ahead.
 
“Welcome to Kerala, buddy! Ready for our adventure?” Raj asked, his smile mirroring the warmth of the tropical sun.
 
“Absolutely! I can’t wait to see Munnar!” Aryan exclaimed, his eyes sparkling with anticipation.
 
The drive to Munnar was a journey through a landscape painted in shades of green. They passed cascading waterfalls and sprawling tea plantations that rolled over the hills like emerald waves.
 
“Look at those waterfalls, Aryan! They remind me of the stories I used to hear from my dad,” Raj reminisced, pointing out the stunning Valara and Cheeyappara waterfalls.
 
“What kind of stories?” Aryan inquired, intrigued.
 
“About how we would explore nature together. He always said, ‘Nature has a way of bringing people closer,’” Raj replied, reflecting on cherished memories.
 
Upon their arrival in Munnar, they checked into their hotel. Later that afternoon, they ventured to Rajamala, the breathtaking Eravikulam National Park.
 
The park was a sanctuary for the endangered Nilgiri Tahr, and Raj felt a sense of urgency to share this experience with Aryan.
 
“Seeing these majestic animals in their natural habitat is unforgettable,” Raj said, looking at the mountain goats.
 
“Can we come back here next year?” Aryan asked, his voice filled with hope.
 
“Absolutely,” Raj smiled, realizing that these moments were what made their bond stronger.`      },
      {
        title: "Day 2: Munnar - Full Day Sightseeing",
        desc: `The sun rose over Munnar, casting a golden hue over the tea estates.
 
After breakfast, Raj and Aryan set out for a day of exploration, eager to uncover the hidden gems of this beautiful region.
 
“Today, we’ll visit Mattupetty Dam and Echo Point,” Raj announced, a sense of adventure in his voice.
 
As they reached Mattupetty Dam, Aryan’s eyes widened in awe. “I can’t believe how gorgeous it is here! Can I take some photos?”
 
“Of course! Remember, photography is about capturing the moment,” Raj encouraged, watching Aryan immerse himself in the beauty around him.
 
At Echo Point, they called out to the mountains, their voices bouncing back to them like laughter. “This is epic, Dad!” Aryan shouted, grinning from ear to ear.
 
Later, as they admired the panoramic views from Pothamedu View Point, Raj felt a wave of nostalgia wash over him. “You know, when I was your age, I dreamed of exploring places like this.”
 
“What was your dream job?” Aryan asked, genuinely curious.
 
“To be a wildlife conservationist. I wanted to protect animals like the ones we’ll see today,” Raj shared, inspiring Aryan to dream big.
`      },
      {
        title: "Day 3: Munnar to Thekkady - Transfer & Sightseeing",
        desc: `After a hearty breakfast, they checked out of their hotel and embarked on their journey to Thekkady, home to the famous Periyar Wildlife Sanctuary. The road wound through thick forests and rolling hills, each bend revealing new wonders.
 
“Ready for Thekkady? It’s going to be an exciting day!” Raj said as they drove.
 
“Yes! I can’t wait to see the wildlife!” Aryan replied, bubbling with excitement.
 
Upon arrival, they checked into their hotel before heading to the sanctuary. The air was thick with anticipation as they entered the park, hoping to catch a glimpse of the diverse wildlife.
 
“Look, Dad! There’s an elephant!” Aryan whispered, awestruck.
 
“Isn’t it amazing? These moments remind us how important it is to protect our wildlife,” Raj said, proud to witness his son’s growing appreciation for nature.
 
Later, they explored a spice plantation, where the rich aroma of cardamom and cinnamon filled the air.
 
“Traveling shows us the beauty of diverse cultures,” Raj mused, “and each experience is a story waiting to be told.”
 
As they settled in for the night, Aryan turned to Raj, his eyes shining with gratitude.
 
“Thanks for bringing me here, Dad. I feel closer to nature… and to you.”
 
“Me too, Aryan. Moments like these are what life is all about,” Raj replied, feeling the warmth of their connection deepening.
`      },
      {
        title: "Day 4: Thekkady to Alleppey - Transfer & Houseboat Stay",
        desc: `The next morning, the father-son duo set off to Alleppey, known for its enchanting backwaters. Raj could hardly contain his excitement as they approached their houseboat, a floating villa waiting to embrace them.
 
“Ready for a unique experience?” Raj asked as they boarded.
 
“Totally! What do you think it will be like?” Aryan inquired, his eyes darting around.
 
“Like living in a floating hotel surrounded by nature,” Raj said, savoring the moment.
 
“Perfect for our photo series!”
 
As they cruised through the backwaters, the sun dipped low in the sky, casting a warm glow over the landscape. They glided past traditional fishing nets and lush paddy fields, a world that felt untouched by time.
 
“I love seeing the locals at work. It’s so different from the city,” Aryan remarked, taking it all in.
 
“Each moment spent here is a reminder of the beauty of simplicity,” Raj added, grateful for the serenity enveloping them.
 
Later, as they shared dinner on the houseboat, Aryan turned to Raj with a smile. “This is the best dinner ever. Thanks for planning this.”
 
“It’s my pleasure, Aryan. It’s about creating memories together,” Raj said, knowing this experience would be etched in their hearts forever.
`
      },
      {
        title: "Day 5: Alleppey to Cochin - Transfer & Sightseeing",
        desc: `On their final day, Raj and Aryan checked out from the houseboat, taking in one last view of the backwaters before heading to Cochin for a half-day sightseeing tour.
 
“I can’t believe it’s almost over! What’s on the agenda?” Aryan asked, a hint of sadness in his voice.
 
“We’ll explore Jew Street, St. Francis Church, and the famous Chinese fishing nets,” Raj replied, trying to lift Aryan’s spirits.
 
As they wandered through Jew Street, Aryan marvelled at the vibrant atmosphere. “This place is so lively! Look at all the handicrafts!”
 
“Each piece tells a story of the culture here. Let’s grab a few souvenirs,” Raj suggested, happy to see Aryan so engaged.
 
At St. Francis Church, they stood in awe of the historical significance surrounding them. “Did you know this is the first European church built in India?” Raj asked.
 
“Really? That’s fascinating!” Aryan exclaimed, eager to learn more.
 
As they headed to Fort Kochi, Raj reflected on their journey. “This trip has been amazing. I’m so glad we did this together.”
 
“Me too, Dad. I feel like I’ve learned so much… about travel and about us,” Aryan replied, his voice filled with sincerity.
 
As they drove to the airport, Raj imparted his final wisdom. “Remember, Aryan, traveling isn’t just about the places we see but the moments we share.”
 
“I’ll remember that, Dad. Let’s plan our next adventure soon!” Aryan said, the anticipation of future journeys lighting up his eyes.
`,
      },
    ],
  },
  {
    img: Darjeeling,
    country: "India",
    place: "Darjeeling",
    tripDur: "6 Days and 5 Nights",
    title:"",
    subDesc:"",
    imgs: [Darjeeling , Darjeeling1 , Darjeeling2 , Darjeeling3 , Darjeeling4 , Darjeeling5 ,Darjeeling6],
    days: [
      {
        title: "Day 1 - Arrival in Bagdogra - Gangtok (120 km/4 hours)",
        desc:
          [`On arrival at the Bagdogra airport (IXB), you will transfer to Gangtok. Visit the Mall Road in Gangtok. Overnight stay at the hotel in Gangtok.`
          ]
      },
      {
        title: "Day 2 - Gangtok - Tsomgo Lake and Baba Mandir - Gangtok",
        desc:
          [`After breakfast, set out for the day excursion to the Tsomgo Lake (40 km from Gangtok). This lake is home to the Brahmini ducks. En route, stop at Kyongnosla. Then, travel to Baba Mandir (at an altitude of around 13,500 feet). Return to Gangtok and retire for the night at the hotel.`
          ]
      },
      {
        title: "Day 3 - Gangtok Sightseeing and transfer to Darjeeling(120 km/4 hours)",
        desc:
          [`After a filling breakfast, start the half day city tour, which covers the Rumtak Monastery, Research Institute of Tibetology, Directorate of Handcrafts & Handloom, Chorten & orchid sanctuary .Overnight stay at Gangtok`
          ]
      },
      {
        title: "Day 4:Gangtok- Darjeeling",
        desc:
          [`After breakfast transfer from Gangtok to Darjeeling. Overnight stay at the hotel in Darjeeling.`
          ]
      },
      {
        title: "Day 5- Darjeeling Sightseeing",
        desc:
          ["Set out for an early morning tour to the Tiger Hills (at around 4 am) to view the sunrise over Kanchenjunga Peak (depends on clear weather). On the way back, visit the Ghoom Monastery and the Batasia Loop. In the afternoon, go for a half-day sightseeing tour of the Padmaja Naidu Himalayan Zoological Park and the Himalayan Mountaineering Institute (closed on Thursday), Lebong Race Course, Ropeway, Peace Pagoda, Tenzing and Gombu Rock, the Tibetan Refugee Self-Help Center (closed on Sunday) and a tea estate. Have a pleasant overnight stay at the hotel in Darjeeling.",
          ]
      },
      {
        title: "Day 6 - Darjeeling - Bagdogra - Departure",
        desc:
          [`After breakfast, transfer to the airport/railway station to catch your flight/train for the return journey.
`]
      },
    ],
  },
  {
    img: Ladakh,
    country: "India",
    place: "Leh And Ladakh",
    title:"Brotherhood Beyond Boundaries",
    subDesc:"It wasn’t just a trip; it was an odyssey of brotherhood, laughter, and discovery. Harish and Rithesh, the inseparable brothers, along with their friends Sam, Irfan, and Rohit, set out to explore the majestic lands of Ladakh, little knowing the adventures and emotions that awaited them.",
    tripDur: "05 Nights | 06 Days",
    imgs: [Ladakh, ladak, ladak1, ladak2, ladak3 , ladak4 , ladak5 , ladak6],
    days: [
      {
        title: "DAY 01: ARRIVE LEH ",
        desc: ["•Acclimatization in Leh with welcome drinks and serene views." ]      },
      {
        title: "DAY 02: LEH - EXCURSION TO SHAM VALLEY (65 KMS / 04 HRS – ONE WAY)",
        desc: ["•	Explore Sham Valley, Hall of Fame, Magnetic Hill, and Alchi Gompa."]
      },
      {
        title: "DAY 03: LEH–NUBRA VALLEY VIA KHARDUNG LA 18,390 FT. (120 KMS / 4 – 5 HRS)",
        desc: ["• Drive to Nubra Valley via the breathtaking Khardung La Pass."],
      },
      {
        title: "DAY 04: NUBRA VALLEY TO PANGONG LAKE (150 KMS / 5 HRS)",
        desc: ["• From Nubra to Pangong Lake, through Shyok Valley's adventurous trails."],
      },
      {
        title: "DAY 05: PANGONG LAKE TO LEH VIA CHANGLA (140 KMS / 6 HRS)",
        desc: ["• Pangong Lake to Leh via Changla Pass, Hemis Gompa, and Rancho School."],
      },
      {
        title: "DAY 06: DEPART LEH (FLY OUT)",
        desc: ["• Bid farewell to Leh, taking memories to cherish forever."],
      },
    ],
    days1: [
      {
        title: "Day 01: Arriving in Leh – A New Horizon",
        desc: `The group arrived in Leh, where the crisp mountain air greeted them. Harish, with his elder-brother tone, said, "Rithesh, remember to hydrate—we’re at 3,500 meters now. I don’t want you fainting like that time in Manali!”
Sam laughed, patting Rithesh on the back, “Relax, Harish! We’ve got the guy who packed more energy bars than we have clothes!”
The day was spent acclimatizing and soaking in the surreal beauty of Leh, setting the tone for what lay ahead.
`      },
      {
        title: "Day 02: Sham Valley – Tales of Valor and Wonder",
        desc: `The drive along the Indus River opened their eyes to the confluence of beauty and history. At the Hall of Fame Museum, Irfan stood still, reading a soldier's letter to his family. “They gave everything, didn’t they?” he whispered. Harish placed a hand on his shoulder, nodding silently.
At Magnetic Hill, Rohit joked, “This place can pull cars uphill. Too bad it can’t pull my grades up!” The laughter echoed against the towering hills.
By the time they reached Shanti Stupa, the group sat quietly, watching the sun dip behind the mountains. Rithesh nudged Harish, “This is perfect. Thanks for convincing us to come, bhai.” Harish smiled, knowing the magic of the mountains was already working on them.
`      },
      {
        title: "Day 03: To Nubra Valley – Over the World’s Highest Pass",
        desc: `Crossing Khardung La Pass was both thrilling and humbling. “Can you believe this is the highest motorable road in the world?” Sam exclaimed, his camera clicking non-stop.
Later, amidst the sand dunes of Nubra Valley, Rithesh tried his hand at riding a double-humped camel. As he struggled to balance, Harish teased, “Looks like the camel is in charge here!” The group burst out laughing.
That evening, sitting by the campfire, Irfan shared a childhood story of his first trip to the mountains with his late father. The mood turned reflective, and Harish broke the silence, saying, “It’s moments like these that remind us to treasure what we have. And we have each other.”
`      },
      {
        title: "Day 04: Nubra to Pangong – A Road Less Traveled",
        desc: `The journey through Shyok Valley tested their spirits with its rugged roads, but the sight of Pangong Lake left them speechless. “This… is what paradise looks like,” Rithesh whispered as the azure waters mirrored the sky.
While dipping their feet in the freezing lake, Sam remarked, “This is where all our plans finally make sense. Life is too short to wait.” Rohit added, “And too long to not share moments like these with brothers like you.”
`      },
      {
        title: "Day 05: Pangong to Leh – A Heartfelt Farewell",
        desc: `Driving back to Leh, the group visited Hemis Gompa and the Rancho School. The nostalgia hit when Irfan joked, “If only our teachers had this view, we might have paid more attention in class!”
At the Shey Palace, Rithesh turned to Harish and said, “You’ve always been my rock, bhai. Thanks for always pushing me to see more, do more.” Harish pulled him into a side hug, replying, “And you’ve always reminded me to slow down and enjoy it all.”
`      },
      {
        title: "Day 06: Depart Leh – Until We Meet Again",
        desc: `As they boarded their flight home, the group looked out at the mountains one last time. Sam summed it up, saying, “We came as travelers, but we’re leaving as a band of brothers.”
Leh-Ladakh wasn’t just a destination—it was a chapter of memories etched in their hearts forever.
`      },
    ],
  },
  {
    img: manali,
    country: "India",
    place: "Shimla & Manali",
    tripDur: "6 Days and 5 Nights",
    title:"",
    subDesc:"",
    imgs: [manali, shimla1, shimla2 , shimla3 , shimla4 , shimla5 , shimla6 , shimla7],
    days: [
      {
        title: "DAY 1: ARRIVE CHANDIGARH – MANALI (320 Kms / 08 hrs)",
        desc: 
[        "On Arrival at Chandigarh Airport, transfer to Manali. On arrival, check into hotel. Dinner and overnight stay in hotel at Manali.",
]      },
      {
        title: "DAY 2: MANALI",
        desc: 
[        "After breakfast, proceed to visit Hadimba Devi Temple, Manu Temple, Tibetan Monastery and Vashisht Village and local market of Manali. Dinner and overnight stay in hotel at Manali.",
]      },
      {
        title: "DAY 3: MANALI",
        desc: 
[        "After breakfast, proceed for half day for Solang Valley and Kothi George (till snow point). Dinner and overnight stay in hotel at Manali.",
]      },
      {
        title: "DAY 4: MANALI – SHIMLA (410 Kms / 10 Hrs)",
        desc: 
[        "After breakfast, check out from hotel and proceed to Shimla by Car (275 kms / 08 hrs). Shimla is capital of himachal former capital of Britishers also set amidst, the snow copper, and shaivalik, mountains which offer some of the most beautiful view of Himalaya Reach there and check in hotel. Dinner and overnight stay in hotel at Shimla.",
]      },
      {
        title: "DAY 5: SHIMLA – KUFRI – SHIMLA (18 Kms / 1½ hrs)",
        desc: 
[        "After breakfast, proceed to visit Indian Institute of Advanced Studies, Sankat Mochan Temple and Jakhu Temple, Afternoon half day excursion to “Kufri”. Evening return just to stroll in the famous shopping place of Shimla town - The Mall & the Ridge. Dinner and overnight stay in hotel at Shimla.",
]      },
      {
        title: "DAY 6: SHIMLA – CHANDIGARH DEPARTURE (145 Kms / 05 Hrs)",
        desc: 
[        "After Breakfast, check out from hotel and transfer to Chandigarh airport to board the flight for onwards destination.",
]      },
    ],
    days1: [
      {
        title: "DAY 1: ARRIVE CHANDIGARH – MANALI (320 Kms / 08 hrs)",
        desc: "On Arrival at Chandigarh Airport, transfer to Manali. On arrival, check into hotel. Dinner and overnight stay in hotel at Manali.",
      },
      {
        title: "DAY 2: MANALI",
        desc: "After breakfast, proceed to visit Hadimba Devi Temple, Manu Temple, Tibetan Monastery and Vashisht Village and local market of Manali. Dinner and overnight stay in hotel at Manali.",
      },
      {
        title: "DAY 3: MANALI",
        desc: "After breakfast, proceed for half day for Solang Valley and Kothi George (till snow point). Dinner and overnight stay in hotel at Manali.",
      },
      {
        title: "DAY 4: MANALI – SHIMLA (410 Kms / 10 Hrs)",
        desc: "After breakfast, check out from hotel and proceed to Shimla by Car (275 kms / 08 hrs). Shimla is capital of himachal former capital of Britishers also set amidst, the snow copper, and shaivalik, mountains which offer some of the most beautiful view of Himalaya Reach there and check in hotel. Dinner and overnight stay in hotel at Shimla.",
      },
      {
        title: "DAY 5: SHIMLA – KUFRI – SHIMLA (18 Kms / 1½ hrs)",
        desc: "After breakfast, proceed to visit Indian Institute of Advanced Studies, Sankat Mochan Temple and Jakhu Temple, Afternoon half day excursion to “Kufri”. Evening return just to stroll in the famous shopping place of Shimla town - The Mall & the Ridge. Dinner and overnight stay in hotel at Shimla.",
      },
      {
        title: "DAY 6: SHIMLA – CHANDIGARH DEPARTURE (145 Kms / 05 Hrs)",
        desc: "After Breakfast, check out from hotel and transfer to Chandigarh airport to board the flight for onwards destination.",
      },
    ],
  },
  {
    img: Guwahati,
    country: "India",
    place: "Guwahati",
    tripDur: "6 Days and 5 Nights",
    title:"",
    subDesc:"",
    imgs: [Guwahati , Guwahati1 , Guwahati2 , Guwahati3 , Guwahati4 , Guwahati5],
    days: [
      {
        title: "Day 1 Guwahati arrival to Shillong",
        desc: 
[        "Arrive at Guwahati airport you will be received and greet by our company representative and proceeds to Shillong (100km, approx) - known as the ‘Scotland of the East’. En-route you will visit the largest manmade lake of Northeast India – Umium Lake. O/N at Shillong.",
]      },
      {
        title: "Day 2 Shillong to Cherrapunji",
        desc:
[         "After breakfast, drive towards Cherrapunjee (65km, approx) – the wettest place in the world. At Cherrapunjee enjoy the numerous waterfalls like Nohkalikai falls, Seven sister falls, and Mawsmai cave. On way to Cherrapunjee will visit Elephant falls. Evening free and stay overnight at Cherrapunji.",
]      },
      {
        title: "Day 3 Excursion to Mawlynnong & drive to Shillong",
        desc: 
[        "Today after breakfast, explore Mawlynnong (90km, approx) – claimed to be the cleanest village of Asia. Mawlynnong offers many interesting sights such as the living root bridge and another strange natural phenomenon of a boulder balancing on another small rock.  Evening drive back to Shillong. Overnight stay at Shillong.",
]      },
      {
        title: "Day 4 Shillong to Guwahati",
        desc: 
[        "Today drive to Guwahati & visit famous Kamakhya Temple and Umananda Temple. Evening free for leisure. Overnight at Guwahati.",
]      },
      {
        title: "Day 5 Departure",
        desc: 
[        "After the breakfast in the hotel drive to Guwahati airport to board the flight for your onward destination. The tour concludes here.",
]      },

    ],
  },
  {
    img: Chardham,
    country: "India",
    place: "Char Dham Yatra",
    tripDur: "12 Nights 13 Days ",
    title:"",
    subDesc:"",
    imgs: [Chardham, Char , Char1],
    days: [
      {
        title: "Day 1: Delhi – Haridwar /Rishikesh (240kms/6-7Hrs):-",
        desc: 
        [`Meet Our Driver At Delhi Airport /Station / Hotel / Home And Drive To Haridwar. Check Into The Hotel Arrival In Haridwar. Evening Visit Mansa Devi Temple & Ganga Aarti At Har Ki Pauri. Overnight Stay At Haridwar.
 An Evening At Ganga Aarti Haridwar: The Ganga Aarti In Hardwar’s Har-Ki-Pauri Is One Of The Famous Rituals In India. It Starts At Around 6.30pm After Sunset, With Large Crowds Gathered Around Both The Banks Of A Canal That Carries The Waters Of Ganges. Loud Speakers Blare Songs In Praise Of Ganga Maiya And Shiva. The Time Of Aarti Sees A Bustle Of Activity On The Ghats A Pack Of Diya Comes Fully Equipped And Is Self-Sufficient! It Has A Wick Lamp Surrounded By Flowers It Lasted For Around 30 Min.
`],
      },
      {
        title: "Day 02: Haridwar/Rishikesh - Barkot (210kms/7-8Hrs):- ",
        desc: 
[        "Morning After Breakfast Transfer To Barkot Via Mussoorie. En-Route Visit Mussoorie Lake & Kempty Fall In Mussoorie. Later Drive To Barkot. On Arrival, Check-In At The Hotel In Barkot For Dinner & Overnight Stay.",
]      },
      {
        title: "Day 03: Barkot - Yamunotri - Barkot {42kms Drive/5 Kms Trek (One Side)}:-",
        desc: 
       [ `Early Morning After Breakfast  Drive To Jankichatti / Phoolchatti & Trek From Here To Yamunotri (6kms) (Either By Walk Or By Horse Or By Doli At Own Cost). After Taking A Bath In Jamunabai Kund’s Warm Water And Cook Rice By Packing It In A Cloth And Dipping It In The Hot Water Of The Hot Kund. Pilgrims Take This Cooked Rice Home As "Prasad". Having Darshan Of “Yamunaji” Return To Jankichatti By Trek. Overnight Stay At Barkot. 
        Hanuman Chatti: The Confluence Of Hanuman Ganga & Yamuna River. 
Yamunotri Temple: Maharani Gularia Of Jaipur Built The Temple In The 19th Century. It Was Destroyed Twice In The Present Century And Rebuilt Again. 
Surya Kund: There Are A Number Of Thermal Springs In The Vicinity Of The Temple, Which Flows Into Numerous Pools. The Most Important Of These Is Surya Kund. 
Divya Shila: A Rock Pillar, Worshipped Before Entering The Yamunotri Temple.
Yamunotri- Yamunotri Is Situated In The Western Region Of The Garhwal Himalayas And Is At A Height Of 3,235 Meters Above Sea Level. Yamunotri Is The Source Of The River Yamuna.The Shrine Of Yamunotri Is Located On The Bandar Poonch Peak. 

        `],
      },
      {
        title: "Day 04: Barkot - Uttarkashi (100 Kms/4Hrs):- ",
        desc: 
        [`Morning After Breakfast,Check Out From Barkot Hotel And Drive To Uttarkashi. Check Into The Hotel Arrival In Uttarkashi. Evening Visit Kashi Vishwanath Temple In Uttarkashi. Overnight Stay And Dinner At Uttarkashi.'
        Uttarkashi: Situated At The Bank Of River Bhagirathi. The Temple Of Lord Vishwanath Is Located Here Where A Massive Iron Trident Is Erected. The Other Important Temples Situated Here Are Ekadash Rudra, Bhairav, Gyaneshwar And Goddess Kuteti Devi. 
        `],
      },
      {
        title: "Day 05: Uttarkashi - Gangotri - Uttarkashi (120kms/5 Hrs Each Side):- ",
        desc: [`Early Morning  Drive To Gangotri(3048 Mts), Enroute At Gangnani Take A Holy Dip In Garam Kund, Have Bath Drive To Gangotri Via Beautiful Harsil Valley. Harsil Is Famous For Its Natural Beauty And For The Majestic Views Of The Deodar Trees And Mountains. On Arrival At Shree Gangotri, Take A Holy Dip In The Sacred River Ganges Which Is Also Called Bhagirathi At Its Origin. Perform Pooja And Darshan, After That Relax For Some Time In The Lovely Surroundings. Later Drive Back To Uttarkashi. Overnight Stay And Dinner At Uttarkashi.
        Gangotri- Gangotri Is The Place High In The Garhwal Himalayas From Where The Holy Ganges Originates. According To The Legend, It Was Here The Ganga Descended On The Earth, When Lord Shiva Released The Mighty River From The Locks Of His Hair. The Temple Of Gangotri, Dedicated To Goddess Ganga Stands On The Banks Of The River
        `],
      },
      {
        title: "Day 06: Uttarkashi – Guptkashi/Phata (290kms/8-9hrs):-  ",
        desc: [`Morning After Breakfast,Check Out From Uttarkashi Hotel And Drive To Guptkashi Via Moolgarh & Lambgoan. Enroute You Can See The Beautiful River Mandakini At Tilwara. The Mandakini River Comes From Kedarnath, Drive Alongside The River To Reach Guptkashi, Visit Ardhnarishwar Temple In Guptkashi. Check Into The Hotel Arrival In Guptkashi. Overnight Stay And Dinner At Guptakashi.
        `],
      },
      {
        title: "Day 07: Guptkashi/Phata – Shri Kedarnath Ji {32kms Drive/19kms Trek (One Side)}:-  ",
        desc: [`Morning After Breakfast Drive To Gaurikund, Trek Start From Gaurikund To Shri Kedarnath Ji (3584 Mts) On Foot Or On By Pony / Doli/ Helicopter. Yatra Members Should Carry Personal Medicines, Heavy Woolen, Toiletries And Clothes For An Overnight Halt At Shri Kedarnath. Check In Hotel. After Freshening Up, Visit Shri Kedarnath Ji Temple & Perform Pooja. In The Evening Also Visit Adi Shankaracharya Samadhi Behind The Temple. Overnight Stay At Kedarnath Hotel.
 
Shri Kedarnath- Is A Majestic Sight, Standing In The Middle Of A Wide Plateau Surrounded By Lofty Snow Covered Peaks. The Temple Of Kedarnath, Located At A Height Of 3,581 Mts, Stand At The Head Of The Mandakini River. The Present Temple, Built In The 8th Century By Adi Shankaracharya, Stands Adjacent To The Site Of An Earlier Temple Built By The Pandavas. The Inner Walls Of The Assembly Hall Are Decorated With Figures Of Various Deities And Scenes From Mythology. Outside The Temple Door A Large Statue Of The Nandi Bull Stands As Guard. It Is Said That Devotees Who Die Here Become One With Shiva Himself. 
`],
      },
      {
        title: "Day 08: Shri Kedarnath – Guptkashi/Phata {19kms(Trek)/32kms 6hrs:-",
        desc:[ `After Breakfast Check Out From Kedarnath Hotel And Again Cross The Kedarnath Trek From Gaurikund Our Cab Will Pick You And Drive Back For Guptkashi . Reach At Guptkashi Hotel And Relax After Long Trekking From Kedarnath To Gaurikund.Check Into The Hotel And Relax.Overnight Stay And Dinner At Guptkashi/Phata Hotel.
`],
      },
      {
        title: "Day 09: Guptkashi- Joshimath/Badrinath/Pipalkoti(180kms/7Hrs):- ",
        desc: [`Morning After Breakfast, Drive To Shri Badrinath. Check In To The Hotel/. Pilgrims After Having A Bath In The Taptkund Have The Darshan Of  Badrivishal & Aarti In The Evening. Brahma Kapal Is Significant For Pind Daan Shraddh Of Ancestors (Pitrus). Overnight Stay At Shri Badrinath.
 
Shri Badrinath- Shri Badrinath Is One Of The Most Important Of All The Four(Char) Dhams In India. This Temple Located Between Nar & Narayan Mountain Ranges And In The Shadow Of Nilkantha Peak At The Height Of 3,133 Mts. It Is The Most Popular Of Vishnu Pilgrimages Among The Five Badries, Also Known As Vishal Badri. 
Tapt Kund: Natural Thermal Springs On The Banks Of The River Alaknanda, Where It Is Customary To Bathe Before Entering The Badrinath Temple. 

Narad Kund: A Recess In The River, Near Tapt Kund, Forming A Pool From Where The Badrinath Idol Was Recovered. 

Mata Murty Temple: Devoted To The Mother Of Sri Badrinathji. Other Important Temples Include Seshnetra Temple, Urvashi Temple And Charan Paduka 
`],
      },
      {
        title: "Day 10: Joshimath/Shri Badrinath/ Pipalkoti - :- ",
        desc: [`Morning After Breakfast,Visit On The Way Narsingh Templle .Visit Day Tour To Auli By Ropeway.(Pay Yourself) Overnight Stay And Dinner At Hotel/jhoshimath/pipalkoti.
There Are Other Interesting Sightseeing Spots Like Mana, Vyas Gufa, Mata Murti, Charanpaduka, Bhimkund And The “Mukh” Of The Saraswati River. Just Within The Three Kms Of Badrinath Ji.
  
Narsingh Temple: This Is An Ancient Temple Of Lord Vishnu In Narsingh Avtar And Main Temple Of Joshimath. When Badrinath Temple Remains Closed During Winter Every Year, One Idol Of Lord Badri Is Brought To Narsingh Temple And Worshiped For Six Months. 
 
Bhim Pul: On The Other Side Of Mana Village, A Massive Rock Forming A Natural Bridge Lies
Over The Roaring Saraswati River. It Presents A Spectacular View Of Water Thundering Down Through The Narrow Passage Under The Rock And Is Believed To Have Been Placed There By Bhim, The Second Eldest Among The Five Pandava Brothers. 

Vyas Gufa (Cave): Near Mana Village, This Is A Rock-Cave Where Ved Vyas Is Believed To Have Composed The Mahabharata And The Pauranic Commentaries. 
`],
      },
      {
        title: "Day 11: Joshimath / Shri Badrinath / Pipalkoti - Haridwar (165kms/5-6hrs):- ",
        desc: 
[        `Morning After Breakfast, Drive For Haridwar Via Rishikesh.Rishikesh’place Of Sages’ Is A Celebrated Spiritual Town On The Bank Of Ganga And Is Surrounded By Shivalik Range Of The Himalayas On Three Sides. It Is Said That When Raibhya Rishi Did Hard Penances, God Appeared By The Name Of ” Hrishikesh ” And This Area Hence Firth Came To Be Known As Rishikesh. Later Visit Rishikeshtemples Sightseeing – Laxmanjhulla, Ram Jhulla. Stay At Haridwar.`,
]      },
      {
        title: "Day 12: Haridwar - Delhi (240kms/6-7Hrs):-",
        desc: 
[        `Morning, After Breakfast, Check-Out From The Hotel And Drive Back To Delhi. On Arr. Delhi, Transfer To Railway Station/Airport.`,
]      },

    ],
  },
];
